<template>
  <div class="page-body overflow-visible">
    <template v-if="isBusy || (items && items.length > 0)">
      <div class="page-table-container overflow-visible">
        <b-table
          id="location-costs"
          ref="location_costs"
          class="custom-table mb-0"
          :busy="isBusy"
          :items="items"
          :fields="fields"
          :per-page="perPage"
          :current-page="currentPage"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-compare="sortPeriodCompare"
          no-provider-filtering
          no-provider-paging
          no-provider-sorting
        >
          <template #table-busy>
            <div class="text-center text-success my-2">
              <b-spinner class="align-middle"/>
              <strong>Загрузка</strong>
            </div>
          </template>

          <template #cell(cost_type)="row">
            <location-cost-type-select
              id="location-cost-type-select"
              ref="location_cost_type_select"
              :is-disabled="isDisabled"
              @onSelect="onSelectLocationCostType($event, row)"
              :value="row.item.cost_type"
            />
          </template>

          <template #cell(period)="row">
            <div style="display: flex;align-items: center;justify-content: left;">
              <b-form-input
                id="input_start_date"
                size="sm"
                class="location-costs-width"
                :disabled="isDisabled"
                type="date"
                v-model.date="row.item.start_date"
              />
              <div class="mx-1">-</div>
              <b-form-input
                id="input_end_date"
                size="sm"
                class="location-costs-width"
                :disabled="isDisabled"
                type="date"
                v-model.date="row.item.end_date"
              />
            </div>
          </template>

          <template #cell(sum)="row">
            <b-form-input
              id="input_sum"
              size="sm"
              class="location-costs-width"
              :disabled="isDisabled"
              autocomplete="off"
              v-model.number="row.item.sum"
            />
          </template>

          <template #cell(comment)="row">
            <b-form-input
              id="input_comment"
              size="sm"
              :disabled="isDisabled"
              autocomplete="off"
              v-model="row.item.comment"
            />
          </template>

          <template #head(action)="row">
            <b-btn variant="link" style="color: #1A9167 !important; text-decoration: none !important;" :disabled="isDisabled || !canLocationEditFinance()" @click.stop="onAddCost()">
              <v-icon name="buttons/plus" :size="12" class="mr-1"/>
              Добавить
            </b-btn>
          </template>

          <template #cell(action)="row">
            <b-button variant="link" @click="onRemoveCost(row)" :disabled="isDisabled">
              <v-icon name="buttons/trash" :size="16"/>
            </b-button>
          </template>
        </b-table>
      </div>

      <div class="page-pagination">
        <pagination-footer
          :total-rows="items.length"
          :per-page="perPage"
          :current-page.sync="currentPage"
          @per-page-change="onPerPageChange"
        />
      </div>
    </template>

    <div v-else class="empty-state-container">
      <v-icon name="navbar/empty_table" :size="90"/>
      <h5>Нет добавленных расходов.</h5>
      <p>Добавьте расходы объекта прямо сейчас</p>
      <b-btn class="custom-btn-primary mt-1" :disabled="isDisabled" @click.stop="onAddCost()">
        <v-icon name="buttons/plus" :size="12" class="mr-1"/>
        Новый расход
      </b-btn>
    </div>
  </div>
</template>

<script>
import locations from "../../network/locations";
  import dateFormatter from "../../utilites/dateFormatter";
  import helpers from "../../utilites/helpers";
  import permissions, {PERM} from "../../utilites/permissions";
  import PaginationFooter from "../../utilites/commonUi/PaginationFooter.vue";
    import LocationCostTypeSelect from "../Catalogs/LocationCostTypes/LocationCostTypeSelect";

export default {
  name: "LocationCosts",
  components: { PaginationFooter, LocationCostTypeSelect },
  mixins: [
    locations,
    dateFormatter, helpers, permissions
  ],
  props: {
    isDisabled: Boolean
  },
  data() {
    return {
      locationId: 0,
      isBusy: false,
      items: [],
      perPage: 10,
      currentPage: 1,
      fields: [
        {
          key: 'cost_type',
          label: 'Тип расхода',
          class: 'location-costs-type',
          sortable: false,
        },
        {
          key: 'period',
          label: 'Период',
          class: 'location-costs-width',
          sortable: true,
        },
        {
          key: 'sum',
          label: 'Сумма',
          class: 'location-costs-width',
          sortable: false,
        },
        {
          key: 'comment',
          label: 'Комментарий',
          sortable: false,
        },
        {
          key: 'action',
          label: "Действия",
          class: 'location-costs-action',
          tdClass: 'align-bottom',
          sortable: false,
        },
      ],
      sortBy: 'period',
      sortDesc: true,
    }
  },
  methods: {
    configure(locationId) {
      this.locationId = locationId;
      this.getCosts();
    },
    async getCosts() {
      this.isBusy = true;
      const result = await this.getLocationCostsById(this.locationId);
      this.isBusy = false;

      if (result.data == null) { return; }

      let costs = result.data.items;
      costs.forEach(function (cost) {
        cost.start_date = this.formatDate(this.getDateFromServerString(cost.start_date));
        cost.end_date = this.formatDate(this.getDateFromServerString(cost.end_date));
      }.bind(this));

      this.items = costs;
    },
    onAddCost() {
      const cost = {
        id: 0,
        cost_type: 0,
        start_date: this.formatDate(new Date()),
        end_date: this.formatDate(new Date()),
        sum: null,
        comment: ''
      };
      this.items.unshift(cost);
      this.setTableOrder();
    },
    onRemoveCost(row) {
      if (row.item) {
        this.deleteRow = row.item;
      }
      const title = "Удаление расходов";
      const message = "Вы уверены, что хотите удалить эти расходы?";

      this.showModalDelete(title, message, () => {
        const index = this.items.findIndex(item => item === row.item);
        this.items.splice(index, 1);
      });
    },
    async saveCosts(locationId) {
      let costs = this.items;

      costs.forEach(function (cost) {
        cost.start_date = this.localISOString(this.getDateToServer(cost.start_date));
        cost.end_date = this.localISOString(this.getDateToServer(cost.end_date));
      }.bind(this));

      return await this.postLocationCosts(costs, locationId);
    },
    onSelectLocationCostType(costType, row) {
      if (costType != null) {
        row.item.cost_type = costType.id;
      } else {
        row.item.cost_type = 0;
      }
    },
    setTableOrder() {
      this.sortBy = 'period';
      this.sortDesc = true;
      this.currentPage = 1;
    },
    canLocationEditFinance() {
      return this.hasPermission([PERM.LOCATION_EDIT_FINANCE]);
    },
    onPerPageChange(newPerPage) {
      this.perPage = Number(newPerPage);
      this.currentPage = 1;
    },
  }
}
</script>

<style>
#location-costs td {
  text-align: center;
}

#location-costs th {
  text-align: center;
  vertical-align: middle;
}

.location-costs-type {
  min-width: 200px;
}

.location-costs-width {
  width: 125px;
}

.location-costs-action {
  width: 140px;
}
</style>



// WEBPACK FOOTER //
// src/components/Locations/LocationCosts.vue